
import { ReactNode } from "react";
import { useAuth } from "@/contexts/AuthContext";
import BottomNavigation from "./BottomNavigation";

interface AppShellProps {
  children: ReactNode;
  showHeader?: boolean;
  showNavigation?: boolean;
  backgroundGradient?: string;
  headerContent?: ReactNode;
  removeBottomPadding?: boolean;
}

const AppShell = ({ 
  children, 
  showHeader = true, 
  showNavigation = true,
  backgroundGradient,
  headerContent,
  removeBottomPadding = false
}: AppShellProps) => {
  const { user } = useAuth();
  
  // Only show navigation for authenticated users
  const shouldShowNavigation = showNavigation && user;
  
  return (
    <div 
      className="app-shell"
      style={backgroundGradient ? { background: backgroundGradient } : undefined}
    >
      {/* Header Zone - Fixed at top */}
      {showHeader && headerContent && (
        <header className="app-shell-header">
          {headerContent}
        </header>
      )}
      
      {/* Content Zone - Scrollable middle */}
      <main className={`app-shell-content ${removeBottomPadding ? 'app-shell-content-no-bottom-padding' : ''}`}>
        {children}
      </main>
      
      {/* Footer Zone - Fixed at bottom */}
      {shouldShowNavigation && (
        <footer className="app-shell-footer">
          <BottomNavigation />
        </footer>
      )}
    </div>
  );
};

export default AppShell;
